import Lottie from "react-lottie-player";
import lottieJson from "../../assets/login-page-animation.json";

export function LoginImageContainer() {
  return (
    <div className="flex aspect-square items-center justify-center rounded-[8px] bg-[#242424] max-[1200px]:hidden">
      <div className="flex h-full w-full items-center justify-center">
        <div className="aspect-w-1 aspect-h-1 flex h-full w-full items-center justify-center">
          <Lottie
            loop
            animationData={lottieJson}
            play
            className="mr-36 h-full w-full"
          />
        </div>
      </div>
    </div>
  );
}
